import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";
import { strings } from "assets/constants";
import axios from "axios";
import { Toast } from "components";
import { _goToLoginStack } from "routers/helper";
import { storage } from "stores";

const networkErrorCode = "ERR_NETWORK";

const client = new QueryClient({
  queryCache: new QueryCache({
    onError: async (error: any) => {
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        storage.set(null);
        return;
      }

      if (error.code !== networkErrorCode) {
        Toast.error({
          message: error?.response?.data?.message ?? strings?.retry,
        });
      }
    },
  }),

  mutationCache: new MutationCache({
    onError: async (error: any) => {
      if (error?.response?.status === 401) {
        return;
      }

      if (error.code !== networkErrorCode) {
        Toast.error({
          message: error?.response?.data?.message ?? strings?.retry,
        });
      } else {
        Toast.error({
          message: strings.connection_error,
        });
      }
    },
  }),
});

export default client;
